import { render } from "./DistrictForm.vue?vue&type=template&id=5036b8d9"
import script from "./DistrictForm.vue?vue&type=script&lang=js"
export * from "./DistrictForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__